<template>
  <panel :title="title" noButton="true" v-has-perms="rolePerm">
    <div>
      <b-form>
        <b-form-row>
          <form-thux-horizontal-input
            :validator="$v.form.code"
            :external-errors="errors['code']"
            :label-form="'Code' | translate"
            class-form="col-12 mb-2"
            labelColsSm="2"
            labelColsLg="2"
            type="text"
            :value="form.code"
            :disabled="!formEditable"
            @change="$set(form, 'code', $event)"
          />
        </b-form-row>
        <b-form-row>
          <form-thux-horizontal-input
            :validator="$v.form.name"
            :external-errors="errors['name']"
            :label-form="'Name' | translate"
            class-form="col-12 mb-2"
            labelColsSm="2"
            labelColsLg="2"
            type="text"
            :value="form.name"
            :disabled="!formEditable"
            @change="$set(form, 'name', $event)"
          />
        </b-form-row>
        <b-form-row>
          <form-thux-horizontal-checkbox
            :validator="$v.form.is_legal_representative"
            :external-errors="errors['is_legal_representative']"
            :label-form="'Legal Representative' | translate"
            class-form="col-12 mb-2"
            label-cols-lg="2"
            label-cols-sm="2"
            :value="form.is_legal_representative"
            :disabled="!formEditable"
            @change="$set(form, 'is_legal_representative', $event)"
          />
        </b-form-row>
      </b-form>
      <div class="mt-3 f-w-600 d-flex justify-content-end">
      <b-button
        class="mr-3"
        variant="default"
        @click.prevent="formEditable ? cancel() : closeForm()">
        {{ formEditable ? 'Cancel' : 'Close' | translate }}
      </b-button>
      <b-button
        variant="primary"
        v-has-perms="editRolePerm"
        @click.prevent="formEditable ? onSubmit() : makeFormEditable()"
        :disabled="$v.form.$invalid">
        {{ formEditable ? 'Save' : 'Edit' | translate }}
      </b-button>
    </div>
    </div>
  </panel>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import { mapActions, mapGetters } from 'vuex'
import { TYPES as CONTACT_ROLE_TYPES } from './store'

import ThuxDetailPanelMixin from '../../../../components/thux-detail-panel/ThuxDetailPanelMixin'

export default {
  name: 'ContactRoleEdit',
  mixins: [ThuxDetailPanelMixin],
  data () {
    return {
      pageName: 'Contact role',
      rolePerm: 'organization_contactrole_retrieve',
      editRolePerm: 'organization_contactrole_update'
    }
  },
  computed: {
    ...mapGetters({
      ...CONTACT_ROLE_TYPES.GENERIC.organization.contactrole.DETAIL.GETTERS
    })
  },
  components: { },
  methods: {
    ...mapActions({
      ...CONTACT_ROLE_TYPES.GENERIC.organization.contactrole.DETAIL.ACTIONS
    })
  },
  validations: {
    form: {
      code: { required },
      name: { required },
      is_legal_representative: { }
    }
  }
}
</script>
